import React from 'react';
import { HeartCrack, AlertCircle, UserX, HelpCircle } from 'lucide-react';
export function PainPoints() {
  return <section className="py-[50px] px-[15px] relative bg-[#1A1035] text-white overflow-hidden" data-id="element-166">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-167">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#7C3AED] rounded-full blur-[100px]" data-id="element-168"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-[#2D1B69] rounded-full blur-[100px]" data-id="element-169"></div>
      </div>

      <div className="container max-w-[700px] mx-auto px-[15px] relative z-[10]" data-id="element-170">
        <div className="bg-gradient-to-r from-[#7C3AED] to-[#6D28D9] text-white p-[12px_20px] text-center font-[700] text-[16px] sm:text-[18px] uppercase rounded-[8px] mb-[30px] shadow-[0_5px_15px_rgba(124,58,237,0.3)] w-full border border-[#A78BFA]/30" data-id="element-171">
          Déjame preguntarte algo incómodo...
        </div>

        <div className="space-y-[20px]" data-id="element-172">
          <div className="flex gap-[15px] p-[20px] border-l-[4px] border-[#DC2626] bg-[#2D1B69]/50 backdrop-blur-sm shadow-[0_4px_10px_rgba(0,0,0,0.2)] rounded-r-[8px] transition-transform hover:translate-x-1" data-id="element-173">
            <AlertCircle className="text-[#DC2626] text-[24px] mt-[2px] flex-shrink-0" data-id="element-174" />
            <div data-id="element-175">
              <p className="text-[#E5E7EB] text-[15px] leading-relaxed" data-id="element-176">
                La última vez que estuviste con tu familiar...{' '}
                <strong className="text-white" data-id="element-177">
                  ¿Sabías exactamente qué decir?
                </strong>{' '}
                ¿O hubo un silencio largo, incómodo, donde buscabas palabras que
                nunca llegaron?
              </p>
            </div>
          </div>

          <div className="flex gap-[15px] p-[20px] border-l-[4px] border-[#DC2626] bg-[#2D1B69]/50 backdrop-blur-sm shadow-[0_4px_10px_rgba(0,0,0,0.2)] rounded-r-[8px] transition-transform hover:translate-x-1" data-id="element-178">
            <HeartCrack className="text-[#DC2626] text-[24px] mt-[2px] flex-shrink-0" data-id="element-179" />
            <div data-id="element-180">
              <p className="text-[#E5E7EB] text-[15px] leading-relaxed" data-id="element-181">
                Ese silencio no significa que no lo amas. Significa que{' '}
                <strong className="text-white" data-id="element-182">
                  nadie te enseñó cómo amar a alguien con cáncer.
                </strong>{' '}
                Y eso se paga con culpa y noches sin dormir.
              </p>
            </div>
          </div>

          <div className="flex gap-[15px] p-[20px] border-l-[4px] border-[#DC2626] bg-[#2D1B69]/50 backdrop-blur-sm shadow-[0_4px_10px_rgba(0,0,0,0.2)] rounded-r-[8px] transition-transform hover:translate-x-1" data-id="element-183">
            <UserX className="text-[#DC2626] text-[24px] mt-[2px] flex-shrink-0" data-id="element-184" />
            <div data-id="element-185">
              <p className="text-[#E5E7EB] text-[15px] leading-relaxed" data-id="element-186">
                ¿Sabes cuál es el mayor miedo de un paciente? No es morir.{' '}
                <strong className="text-white" data-id="element-187">
                  Es sentirse solo mientras todavía está vivo.
                </strong>{' '}
                Y tú darías cualquier cosa por no dejarlo solo, pero estás
                emocionalmente perdido.
              </p>
            </div>
          </div>

          <div className="flex gap-[15px] p-[20px] border-l-[4px] border-[#DC2626] bg-[#2D1B69]/50 backdrop-blur-sm shadow-[0_4px_10px_rgba(0,0,0,0.2)] rounded-r-[8px] transition-transform hover:translate-x-1" data-id="element-188">
            <HelpCircle className="text-[#DC2626] text-[24px] mt-[2px] flex-shrink-0" data-id="element-189" />
            <div data-id="element-190">
              <p className="text-[#E5E7EB] text-[15px] leading-relaxed" data-id="element-191">
                Los médicos explican tratamientos. Los enfermeros explican
                medicamentos. Pero{' '}
                <strong className="text-white" data-id="element-192">
                  nadie te explicó cómo ser el soporte emocional
                </strong>{' '}
                de alguien que lucha por su vida.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}